// extracted by mini-css-extract-plugin
export default {"root":"TopBar_root__WU8es","content":"TopBar_content__nHiDJ","title":"TopBar_title__hlP6n","subtitle":"TopBar_subtitle__RDuJ3","btn":"TopBar_btn__ZI317"};